"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("../utils");
var ToggleBrandItem = /** @class */ (function (_super) {
    __extends(ToggleBrandItem, _super);
    function ToggleBrandItem(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleBrandHandler = _this.toggleBrandHandler.bind(_this);
        return _this;
    }
    ToggleBrandItem.prototype.toggleBrandHandler = function () {
        var _a = this.props, brand = _a.brand, active = _a.active, onClick = _a.onClick;
        if (active) {
            return;
        }
        onClick(brand.value);
    };
    ToggleBrandItem.prototype.render = function () {
        var _a = this.props, brand = _a.brand, active = _a.active;
        return (React.createElement("div", { className: "tradein-toggle-brand__item " + (active ? 'tradein-toggle-brand__item_active' : ''), onClick: this.toggleBrandHandler },
            React.createElement("div", { className: "tradein-toggle-brand__discount" },
                React.createElement("div", { className: "tradein-toggle-brand__title" }, brand.title),
                !!brand.price && (React.createElement(React.Fragment, null,
                    React.createElement("div", null, "\u0412\u044B\u0433\u043E\u0434\u0430:"),
                    React.createElement("div", { className: "tradein-toggle-brand__price" },
                        utils_1.formatPrice(brand.price),
                        " \u0420\u0423\u0411.")))),
            React.createElement("div", { className: "tradein-toggle-brand__checkbox" })));
    };
    return ToggleBrandItem;
}(React.PureComponent));
exports.default = ToggleBrandItem;
